export * from '@kaidam/fc-shared/src/frontend/store/modules/network'
import defaultModule from '@kaidam/fc-shared/src/frontend/store/modules/network'
export default defaultModule